module.exports = __webpack_public_path__ + "img/introduction.93eb0aa1.png";